import React, { FC } from 'react';
import { Money } from 'generated/graphql';
import { ThreeColumnsItineraryType } from '@components/Results/Components/ThreeColumnsItinerary/types';
import { Flex, Body, Box } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import {
  AlternativeItineraryAdditionalInformation,
  AlternativeItineraryValuePropositionType,
} from 'clientState/providers/AlternativeItineraryProvider/types';
import { calculatePriceDifference } from '../AlternativeItineraryDoubleCardLayer/AlternativeItineraryDoubleCardDecorators';

type BottomAlternativeItineraryDecoratorProps = {
  itinerary?: ThreeColumnsItineraryType;
  valueProposition: AlternativeItineraryValuePropositionType;
  valuePropositions?: AlternativeItineraryValuePropositionType[];
  additionalInformation?: AlternativeItineraryAdditionalInformation;
  discountAmount?: Money | undefined;
  selectedItinerary?: ThreeColumnsItineraryType;
  numPassengers?: number;
};

export const BottomAlternativeItineraryDecorator: FC<
  BottomAlternativeItineraryDecoratorProps
> = ({ itinerary, selectedItinerary, valueProposition, discountAmount }) => {
  const { t } = useTranslation();
  const { priceDifference } = calculatePriceDifference(
    itinerary,
    selectedItinerary
  );

  const discountContent =
    valueProposition === 'discount' && priceDifference < 0
      ? 'cheaper'
      : 'expensive';

  return (
    <Box
      backgroundColor="positive.50"
      position="relative"
      pl="small"
      pr="small"
      pt="1x_small"
      pb="2x_small"
      borderBottomLeftRadius="regular"
      borderBottomRightRadius="regular"
      sx={{
        margin: '-5px auto 0',
      }}
      data-testid="price-tendency-box"
    >
      <Flex>
        <Body type="small" color="neutral.0">
          {t(
            `alternativeItinerary.ribbon.${
              discountAmount && discountAmount.amount !== 0
                ? 'cheaper'
                : discountContent
            }`
          )}
        </Body>
      </Flex>
    </Box>
  );
};

export default BottomAlternativeItineraryDecorator;
